// extracted by mini-css-extract-plugin
export default {"dropdown":"AttributeSelection_dropdown__Y0Tpg"};